import { render, staticRenderFns } from "./q-radio.vue?vue&type=template&id=d2f19c5a&scoped=true&"
import script from "./q-radio.vue?vue&type=script&lang=js&"
export * from "./q-radio.vue?vue&type=script&lang=js&"
import style0 from "./q-radio.vue?vue&type=style&index=0&id=d2f19c5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f19c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yangxinyuan/vhall/vhall_questionnaire_service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2f19c5a')) {
      api.createRecord('d2f19c5a', component.options)
    } else {
      api.reload('d2f19c5a', component.options)
    }
    module.hot.accept("./q-radio.vue?vue&type=template&id=d2f19c5a&scoped=true&", function () {
      api.rerender('d2f19c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questionnaire/q-radio.vue"
export default component.exports